export default function initDatasheetsPopup() {
    document.querySelectorAll('.product-hero.has-datasheets').forEach($productHeroContainer => {
        if ($productHeroContainer.querySelectorAll('.button.datasheet')) {
            let $datasheetButton = $productHeroContainer.querySelector('.button.datasheet');
            //to je datasheet popup --> let $triggerPopUp = $currentProduct.querySelector('.product-status > .link-container .popup-container');

            let $datasheetPopup = $productHeroContainer.querySelector('.datasheets-popup');
            let $datasheetPopupArrow = $productHeroContainer.querySelector('.datasheets-arrow');

            document.addEventListener('click', function popupMouseEvent(e) {
                if ($datasheetButton.contains(e.target)) {
                    e.preventDefault();
                }
                if ($datasheetButton.contains(e.target) && !$datasheetButton.classList.contains('is-active')) {
                    $datasheetButton.classList.add('is-active');
                    $datasheetPopup.classList.add('is-active');
                    $datasheetPopupArrow.classList.add('is-active');
                } else if (
                    !$datasheetPopup.contains(e.target) ||
                    ($datasheetButton.contains(e.target) && $datasheetButton.classList.contains('is-active'))
                ) {
                    $datasheetButton.classList.remove('is-active');
                    $datasheetPopup.classList.remove('is-active');
                    $datasheetPopupArrow.classList.remove('is-active');
                }
            });

            let $downloadPopup = null;
            let $downloadPopupContent = null;
            let $acceptButton = null;
            let $declineButton = null;
            let $closeDialog = null;

            if (
                $productHeroContainer.querySelectorAll('.download-popup') !== null &&
                $productHeroContainer.querySelectorAll('.download-popup') !== undefined
            ) {
                if (
                    $productHeroContainer.querySelectorAll('.download-popup')[0] !== null &&
                    $productHeroContainer.querySelectorAll('.download-popup')[0] !== undefined
                ) {
                    $downloadPopup = $productHeroContainer.querySelectorAll('.download-popup')[0];
                }

                if (
                    $productHeroContainer.querySelectorAll('.download-popup-content')[0] !== null &&
                    $productHeroContainer.querySelectorAll('.download-popup-content')[0] !== undefined
                ) {
                    $downloadPopupContent = $productHeroContainer.querySelectorAll('.download-popup-content')[0];
                }
                if ($downloadPopup !== null && $downloadPopup !== undefined) {
                    if (
                        $downloadPopup.querySelectorAll('.accept')[0] !== null &&
                        $downloadPopup.querySelectorAll('.accept')[0] !== undefined
                    ) {
                        $acceptButton = $downloadPopup.querySelectorAll('.accept')[0];
                    }

                    if (
                        $downloadPopup.querySelectorAll('.decline')[0] !== null &&
                        $downloadPopup.querySelectorAll('.decline')[0] !== undefined
                    ) {
                        $declineButton = $downloadPopup.querySelectorAll('.decline')[0];
                    }

                    if (
                        $downloadPopup.querySelectorAll('.close-dialog')[0] !== null &&
                        $downloadPopup.querySelectorAll('.close-dialog')[0] !== undefined
                    ) {
                        $closeDialog = $downloadPopup.querySelectorAll('.close-dialog')[0];
                    }
                }
            }

            if (
                $downloadPopup !== null &&
                $downloadPopupContent !== null &&
                $acceptButton !== null &&
                $declineButton !== null &&
                $closeDialog !== null
            ) {
                $productHeroContainer.querySelectorAll('a.has-disti-files').forEach($link => {
                    $link.addEventListener('click', event => {
                        event.preventDefault();
                        const url = event.srcElement.attributes.href.value;

                        if ($productHeroContainer.classList.contains('show-dialog')) {
                            $productHeroContainer.classList.remove('show-dialog');
                        } else {
                            $productHeroContainer.classList.add('show-dialog');
                        }

                        function hideDialog() {
                            if (
                                $downloadPopup !== null &&
                                $downloadPopup !== undefined &&
                                $productHeroContainer.classList.contains('show-dialog')
                            )
                                $acceptButton.removeEventListener('click', openDialog);
                            $closeDialog.removeEventListener('click', closeDialog);
                            $declineButton.removeEventListener('click', closeDialog);
                            $downloadPopup.removeEventListener('click', closeDialog);
                            $productHeroContainer.classList.remove('show-dialog');
                        }

                        function openDialog(accept) {
                            $acceptButton.removeEventListener('click', openDialog);
                            accept.preventDefault();
                            window.open(url);
                            hideDialog();
                        }

                        $acceptButton.addEventListener('click', openDialog);

                        function closeDialog(decline) {
                            if (
                                !$downloadPopupContent.contains(decline.target) ||
                                $declineButton.contains(decline.target) ||
                                $closeDialog.contains(decline.target)
                            ) {
                                decline.preventDefault();
                                hideDialog();
                            }
                        }

                        $closeDialog.addEventListener('click', closeDialog);
                        $declineButton.addEventListener('click', closeDialog);
                        $downloadPopup.addEventListener('click', closeDialog);

                        document.addEventListener('keydown', function (e) {
                            if (e.code === 'Escape') {
                                hideDialog();
                            }
                        });
                    });
                });
            }
        }
    });
}
